import React from "react";
import educationIcon from "../../assets/new-education/Education_icon.svg";
import "./index.css";
import { useTranslation } from "react-i18next";

export const EducationIntroCard = ({ isWhite, title, icon, width, height }) => {
  const { t } = useTranslation();

  return (
    <div
      className={"education-intro-card-container" + (isWhite ? " white" : "")}
    >
      <h5
        style={{
          fontWeight: "bold",
          color: isWhite ? "#193665" : "white",
          fontSize: "16px",
          marginBottom: "10px",
        }}
      >
        {title ? title : t("EDUCATION")}
      </h5>

      <img
        src={icon ? icon : educationIcon}
        alt="Education icon"
        width={width ? width : 55}
        height={height ? height : 107}
        style={{ objectFit: "cover", marginBottom: "20px" }}
      />
    </div>
  );
};
